import { useEffect } from "react"

import useCurrentClient from "./useCurrentClient"
import { useSendbird } from "../../../components/sendbird/SBProvider"

const useSetCurrentSBChannel = () => {
  const { setCurrentChannel, channels } = useSendbird()
  const { currentCoachingGroup } = useCurrentClient()
  const { getChannelByUrl } = useSendbird()

  // Change the current sendbird channel when the coaching group changes
  useEffect(() => {
    if (!currentCoachingGroup || !channels) return
    const channel = getChannelByUrl(currentCoachingGroup?.sendbird_channel_url)
    setCurrentChannel(channel)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCoachingGroup, channels])
}

export default useSetCurrentSBChannel
